import axios, { AxiosResponse } from 'axios';
const url =
  process.env.REACT_APP_BACK_URL || process.env.REACT_APP_BACK_URL_DEV;
class LanguagesService {
  getLanguages(): Promise<AxiosResponse> {
    return axios.get(`${url}/languages`);
  }
}
export default new LanguagesService();
